import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from '../../../../services/app.service';
import { ConfirmComponent } from '../dialog/confirm.component';
import { DossierAlerteDialogComponent } from '../dialog/dossier-alerte-dialog.component';
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'

const KEY = 'dossier-alerte'

@Component({
    selector: 'dossier-alerte',
    templateUrl: './dossier-alerte.component.html',
    styleUrls: ['./dossier-alerte.component.scss']
})
@Stringable({
	path: 'views/partials/layout/dossier-alerte',
	key: KEY,
})
export class DossierAlerteComponent {
	@StringableValues(KEY)
	strings: any
	
    @Input() dossier: any;
    tier: any;
    canAddNewAlerts: boolean = false;
    listAlerts: any;
    newCreatedId: any = null;
    constructor(
        private appService: AppService,
        public dialog: MatDialog,
        private changeDetectorRef: ChangeDetectorRef
    ) {

    }

    ngOnInit(): void {
	   if ( this.dossier!=undefined) {
	        console.log("alerte",this);
	        /*
	        if (this.dossier.tiers!=undefined && this.dossier.tiers.type!=undefined)
    				this.loadAlerts( this.dossier.tiers.type);
	        */
	        this.listAlerts = this.dossier.alerts;
	        this.tier = this.dossier.tiers;
	        this.canAdd();
		}
    }
    
    loadAlerts(type:string) {
    this.appService.tagsByTiersType(type)
      .subscribe(list => {
	    console.log("alerts",list.result);
        for (var i = 0; i < list.result.length; i++)
         	 this.listAlerts.push(list.result[i]);
      });
  }
    
    openTagAddModal(tiersID: any) {
        const dialogRef = this.dialog.open(DossierAlerteDialogComponent, {
            data: {
                tiersID: tiersID,
                type:this.dossier.tiers.type
            }
        })
        dialogRef.afterClosed().subscribe((res) => {

            if (res) {
				
				if (res.libelle.length>0)
					res.selectedType.libelle=res.libelle
				
                this.appService.addTagToTiers(res.selectedType.code, tiersID, {
									label: res.libelle 
								}).subscribe((data) => {
                    this.listAlerts.push(res.selectedType);
                    this.changeDetectorRef.detectChanges();

                    this.newCreatedId = data.result.tag
                    this.canAdd();
                });
            }
        })
    }

    removeTagFromTiers(tag: any, tiersID: string) {
        let tag_id = tag.atagTiersID || this.newCreatedId;

        const dialogRef = this.dialog.open(ConfirmComponent, {
            data: {
                libelle: this.strings.confirmDelete
            }
        })
        dialogRef.afterClosed().subscribe((res) => {
            if (res === 'true') {
                this.appService.removeTagFromTiers(tag_id, tiersID).subscribe((data) => {

                    if (data) {

                        this.listAlerts.splice(this.listAlerts.indexOf(tag), 1)
                    }
                    this.canAdd();
                    this.changeDetectorRef.detectChanges();
                });
            }
        })
    }
    hexToRgbA(hex: string, alpha: any = 200) {
        let color;
        let newAlpha = Number.parseInt(alpha);

        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            color = hex.substring(1).split('');
            if (color.length == 3) {
                color = [color[0], color[0], color[1], color[1], color[2], color[2]];
            }
            color = '0x' + color.join('');
            return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')';
        }
    }

    canAdd() {
        this.appService.canAddNewTags(this.tier.ID).subscribe((data: any) => {
            this.canAddNewAlerts = data.result > 0;
            this.changeDetectorRef.detectChanges();
        })
    }

}
